import { render, staticRenderFns } from "./gradient.vue?vue&type=template&id=d63a2f08"
import script from "./gradient.vue?vue&type=script&lang=js"
export * from "./gradient.vue?vue&type=script&lang=js"
import style0 from "./gradient.vue?vue&type=style&index=0&id=d63a2f08&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports